import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Errors, LeaderboardService, LocalService } from '../../../../core';

@Component({
  selector: 'app-challenge-entries',
  templateUrl: './challenge-entries.component.html',
  styleUrls: ['./challenge-entries.component.scss'],
})
export class ChallengeEntriesComponent implements OnChanges, AfterViewInit {
  @Input() entries: any[] = [];
  @Input() leaderboardType: string = '';
  @Input() isManager: boolean = false;
  @Input() userProfile: any;
  @Input() size: number = 5;

  page: number[] = [];
  challengeTableColumns: any[] = [];
  errors: Errors = { errors: {} };

  showArchModal: boolean = false;
  archModalData: any[] = [];

  showTrainingModal: boolean = false;
  trainingModalCourses: any[] = [];
  trainingModalLearningMaps: any[] = [];

  showAllTrainingsModal: boolean = false;
  allTrainingsCourses: any[] = [];
  allTrainingsLearningMaps: any[] = [];

  @ViewChild('tracksCompletedCellTemplate') tracksCompletedCellTemplate!: TemplateRef<any>;
  @ViewChild('rankTemplate') rankTemplate!: TemplateRef<any>;
  @ViewChild('participantTemplate') participantTemplate!: TemplateRef<any>;
  @ViewChild('bookingsTemplate') bookingsTemplate!: TemplateRef<any>;
  @ViewChild('earningsTemplate') earningsTemplate!: TemplateRef<any>;

  constructor(
    private leaderboardService: LeaderboardService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entries'] && this.entries && this.entries.length > 0) {
      this.page = [];
      this.challengeTableColumns = [];
      this.autoLoadChallengeData();
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  autoLoadChallengeData(): void {
    this.entries.forEach((challenge: any, index: number) => {
      this.getMoreLeaderboards(index, challenge.id);
    });
  }

  getMoreLeaderboards(index: number, challengeId: any, event?: any): void {
    this.page[index] = event ? event : 1;

    const profile = this.userProfile || LocalService.get('userProfile');
    const pathParams = {
      type: this.leaderboardType,
      challengeId: challengeId,
      companyId:
        profile && profile.hasOwnProperty('userType') && profile.userType === 'PAM'
          ? profile.company.id
          : '',
    };
    const queryParams = {
      page: this.page[index] - 1,
      size: this.size,
    };

    this.leaderboardService.getMoreChallenges(pathParams, queryParams).subscribe(
      (data) => {
        if (data && data.content.length) {
          if (event) {
            this.entries[index].entries.content = [];
            this.entries[index].entries.content = data.content;
          } else {
            this.entries[index].entries = data;
            this.entries[index].open = true;
            this.challengeTableColumns = this.generateTableColumns(data.content);
          }
        } else {
          this.entries[index].entries = { content: [], totalElements: 0 };
        }
      },
      (err) => {
        this.entries[index].entries = { content: [], totalElements: 0 };
        this.errors = err;
      }
    );
  }

  generateTableColumns(content: any[]): any[] {
    if (!content || !content[0]) {
      return [];
    }

    const columns: any[] = [
      { field: 'rank', header: 'Rank', align: 'left', isBold: true, cellTemplate: this.rankTemplate },
      { field: 'user', header: 'Participant Name', align: 'left', cellTemplate: this.participantTemplate },
      { field: 'country', header: 'Country', align: 'left' },
      { field: 'bookingsSoldOrClaimed', header: 'Bookings', align: 'left', isBold: true, cellTemplate: this.bookingsTemplate },
      { field: 'creditsEarned', header: 'Earnings', align: 'left', isBold: true, cellTemplate: this.earningsTemplate },
    ];

    if (content[0].hasOwnProperty('coursesCompletedList')) {
      columns.push({
        field: 'coursesCompletedList',
        header: 'Tracks Completed',
        align: 'left',
        cellTemplate: this.tracksCompletedCellTemplate,
      });
    }

    return columns;
  }

  splitData(value: any): string {
    const parseValue = parseFloat(value);
    return parseFloat(parseValue.toLocaleString()).toLocaleString();
  }

  showArchTargetBooking(event: any, list: any): void {
    this.archModalData = list.architectureTargets;
    this.showArchModal = true;
    event.stopPropagation();
  }

  showTraingsCompletion(list: any): void {
    this.trainingModalCourses =
      list.coursesCompletedList && list.coursesCompletedList.length > 0
        ? list.coursesCompletedList
        : [];
    this.trainingModalLearningMaps =
      list.learningMapsCompletedList && list.learningMapsCompletedList.length > 0
        ? list.learningMapsCompletedList
        : [];
    this.showTrainingModal = true;
  }

  showAllTrainingsList(event: any, list: any): void {
    this.allTrainingsCourses = list.coursesInfo || [];
    this.allTrainingsLearningMaps = list.learningMapsInfo || [];
    this.showAllTrainingsModal = true;
    event.stopPropagation();
  }
}
